import { Pipe, PipeTransform } from '@angular/core';
// eslint-disable-next-line import/no-unresolved
import { round } from 'mathjs';

@Pipe({ name: 'roundFloat' })
export class RoundFloatPipe implements PipeTransform {
  transform(x: number, n = 3) {
    return round<number>(x ?? 0, n);
  }
}
